import { useRef } from 'react';
import isEqual from 'react-fast-compare';
import isEqualWith from 'lodash/isEqualWith';

// exact same as above but returns the ref instead - useful for always getting up-to-date value in
// effects without forcing a re-run when it changes
export function useDeepEqualMemoRef<T>(value: T) {
  const memoizedValue = useRef(value);

  // only update the value if it's not deep equal
  if (!isEqual(value, memoizedValue.current)) {
    memoizedValue.current = value;
  }

  return memoizedValue;
}

// Similar to above, but uses a customizable item equality compare function
export function useDeepEqualCustomMemo<T>(
  value: T,
  customComparison: (a: T, b: T) => boolean | undefined
) {
  const memoizedValue = useRef(value);

  // only update the value if it's not deep equal
  if (!isEqualWith(value, memoizedValue.current, customComparison)) {
    memoizedValue.current = value;
  }

  return memoizedValue.current;
}
